import type {ProjectPickerBaseProject} from '@github-ui/item-picker-project'
import {AddToProjectsBulkActionServerQuery} from '@github-ui/server-persisted-queries'
import type {AddToProjectsBulkActionServerQueryQuery} from '@github-ui/server-persisted-queries/types/AddToProjectsBulkActionServerQuery'
import {reactFetchJSON} from '@github-ui/verified-fetch'

export function issueProjectsQueryKey(issueIds: readonly string[]) {
  return ['issue-projects', {issueIds: [...issueIds].sort()}] as const
}

export async function fetchIssueProjects(
  issueIds: readonly string[],
  signal?: AbortSignal,
): Promise<AddToProjectsBulkActionServerQueryQuery> {
  const params = new URLSearchParams({queryId: AddToProjectsBulkActionServerQuery})
  for (const issueId of issueIds) params.append('ids[]', issueId)

  const response = await reactFetchJSON(`/issues/bulk-projects?${params}`, {signal})
  if (!response.ok) throw new Error(`Bulk project query failed (${response.status})`)

  const payload = (await response.json()) as {
    data?: AddToProjectsBulkActionServerQueryQuery
    errors?: unknown[]
  }
  if (payload.errors?.length || !payload.data) throw new Error('Bulk project query returned errors')

  return payload.data
}

export function projectsAppliedToAll(data: AddToProjectsBulkActionServerQueryQuery): ProjectPickerBaseProject[] {
  const projectsByIssue = data.nodes.map(node =>
    node?.__typename === 'Issue'
      ? (node.projectItems?.edges ?? []).flatMap(edge => (edge?.node?.project ? [edge.node.project] : []))
      : [],
  )
  const firstIssueProjects = projectsByIssue[0] ?? []
  return firstIssueProjects.filter(project =>
    projectsByIssue.every(issueProjects => issueProjects.some(candidate => candidate.id === project.id)),
  )
}
